import { useMemo } from 'react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'

import usePaginatedQuery from '@/hooks/usePaginatedQuery'

export type QueryVariables = {
  filter: GraphQL.QuerySpaceFilter
  sort: GraphQL.QuerySpaceSort
}

export default function usePaginatedSpaces(variables: QueryVariables) {
  const { items: fragmentItems, ...rest } = usePaginatedQuery(
    AdminAPI.space.QUERY,
    variables,
    {
      document: AdminAPI.space.CHANGED,
      typename: 'Space'
    }
  )

  const items = useMemo(() => {
    return fragmentItems?.map(item =>
      getFragment(SharedAPI.space.SPACE_FRAGMENT, item)
    )
  }, [fragmentItems])

  return {
    items,
    ...rest
  }
}
